// @ts-check
import React from 'react';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import { TextAreaInput } from './TextAreaField';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawICD10Input = props => (
  <div>
    <div>
      <a href="http://www.icd10data.com/ICD10CM/Codes" target="_blank" rel="noopener noreferrer">
        ICD-10 Reference
      </a>{' '}
      (opens a new tab)
    </div>
    <div>
      <TextAreaInput {...props} />
    </div>
  </div>
);

RawICD10Input.displayName = 'RawICD10Input';

const ICD10Input = connectFormComponentToReduxForm(wrapFormComponentWithError(RawICD10Input));

export { ICD10Input };
export default wrapFormComponentWithLabelAndError(RawICD10Input);
